import React from 'react';
import type { Event } from '@/types/event';
import DOMPurify from 'dompurify';

const MainContent: React.FC<{ event: Event, quota?: any }> = ({ event, quota: myQuotas = {} }) => {
  // Sanitize the HTML string
  // const sanitizedHtml = DOMPurify.sanitize(event.networking_goals as any);
  console.log('Event in MainContent:', event);

  const OrangeBullet = () => (
    <div className="flex-shrink-0 w-4 h-4 mr-2 mt-1 flex items-center justify-center">
      <div className="w-4 h-4 bg-orange-500/20 rounded-full flex items-center justify-center">
        <div className="w-2 h-2 bg-[#FF8904] rounded-full"></div>
      </div>
    </div>
  );
  
  return (
    <div className="flex-col text-start">
      {/* Title */}
      <div className="text-center mb-6 sm:mb-8">
        <h1 className="text-white text-2xl sm:text-3xl lg:text-4xl font-normal leading-tight sm:leading-10 tracking-tight line-clamp-2 px-2">
          {event.title}
        </h1>
      </div>

      {/* About This Event Section */}
      <div className="bg-white/25 rounded-xl sm:rounded-2xl shadow-lg outline outline-1 outline-white/10 p-4 sm:p-6 mb-4 sm:mb-6">
        <h2 className="text-white text-lg sm:text-xl font-normal leading-6 sm:leading-7 mb-3 sm:mb-4">
          About This Event
        </h2>
        <div className="h-32 sm:h-40 pr-2 overflow-y-auto scrollbar-thin scrollbar-thumb-blue-500/30 scrollbar-track-gray-200/10">
          <p className="text-white/90 text-sm sm:text-base font-normal leading-5 sm:leading-6 text-justify">
            {event.description || 'No description...'}
          </p>
        </div>
      </div>

      {/* What You'll Learn Section */}
      <div className="bg-white/25 rounded-xl sm:rounded-2xl shadow-lg outline outline-1 outline-white/10 p-4 sm:p-6 mb-4 sm:mb-6">
        <h2 className="text-white text-lg sm:text-xl font-normal leading-6 sm:leading-7 mb-3 sm:mb-4">
          What You'll Learn
        </h2>
        <div className="h-40 sm:h-56 pr-2 overflow-y-auto scrollbar-thin scrollbar-thumb-blue-500/30 scrollbar-track-gray-200/10">
          {event.next_schedule?.learning_objectives && event.next_schedule?.learning_objectives.length > 0 ? (
              <ul className="space-y-3 sm:space-y-4">
                {event.next_schedule?.learning_objectives.map((objective: string, index: number) => (
                  <li key={index} className="flex items-start">
                    <OrangeBullet />
                    <span className="text-white/90 text-sm sm:text-base font-normal leading-5 sm:leading-6">
                      {objective}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-white/90">No learning objectives...</p>
            )}
        </div>
      </div>
    </div>
  );
};

export default MainContent;